import './PetType.scss';
import { useEffect, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/v2/pet-cat.svg';
import { ReactComponent as PetDog } from '@/assets/img/v2/pet-dog.svg';

type PetTypeProps = {
  onChange: (type: string) => void;
  value?: string;
  defaultPetType?: string;
};
export const PetType = ({ onChange, value, defaultPetType }: PetTypeProps) => {
  const [petType, setPetType] = useState<string>();

  useEffect(() => {
    if(defaultPetType) {
      onChange(defaultPetType);
      setPetType(defaultPetType);
    }
  }, []);
  useEffect(() => {
    petType && onChange(petType);
  }, [petType]);
  
  useEffect(() => {
    value && setPetType(value);
  }, [value]);
  console.log("defaultPetType", defaultPetType);
  
  return (
    <div className="pet-type-container">
      {(!defaultPetType || defaultPetType.toLowerCase() === 'dog') && <div
        className={`pet-type dog ${petType?.toLowerCase() === 'dog' ? 'selected' : ''}`}
        onClick={() => setPetType('dog')}
      >
        <PetDog className='dog' />
        <div className="">
          <div className='title'>Dog</div>
          {/* <div className='desc'>{isBrowser ? 'I have a ' : ''} pet doggie</div> */}
        </div>
      </div>}
      {(!defaultPetType || defaultPetType.toLowerCase() === 'cat') && <div
        className={`pet-type cat ${petType?.toLowerCase() === 'cat' ? 'selected' : ''}`}
        onClick={() => setPetType('cat')}
      >
        <PetCat className='cat' />
        <div className="">
          <div className="title">Cat</div>
          {/* <div className="desc">{isBrowser ? 'I have a ' : ''} cute kittie</div> */}
        </div>
      </div>}
    </div>
  );
};
